import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-not-found',
  template: ``,
})
export class ExternalRedirectComponent {
  constructor(private readonly route: ActivatedRoute) {
    const externalUrl = this.route.snapshot.paramMap.get('externalUrl') ?? '';
    if (externalUrl !== '') {
      window.location.href = externalUrl;
    }
  }
}
